
import Dot from '@/components/UntitledUI/Dot.vue'
import Icon from '@/components/UntitledUI/Icon.vue'
import Tippy from '@/components/common/Tippy.vue'

export default {
    name: 'SearchResult',
    components: { Dot, Icon, Tippy },
    props: {
        doc: {
            type: Object,
            required: true
        },
        page: {
            type: Number,
            default: 1
        },
        searchToken: {
            type: String,
            default: null
        }
    },
    methods: {
        getUrl (doc) {
            const name = `-${this.$helpers.slugify(doc.name)}`
            const base = doc.type !== 'CONTRACT_TEMPLATE'
                ? 'File' : 'Contract-Template'
            let url = `/${base}/${doc.hash}${name}`
            if (['CONTENT', 'TITLE', 'PAGE'].includes(doc.type)) {
                url += `?page=${doc.page}`
            }

            return this.localePath(url)
        },
        contentTypeLabel (type) {
            return {
                summary: this.$t('search results type summary'),
                summary_auto: this.$t('search results type ai summary'),
                content: this.$t('search results type content')
            }[type] ?? this.$t('search results type content')
        },
        showResult (doc) {
            if (doc.locked) { return }
            this.$router.push({
                hash: '$wait',
                path: this.getUrl(doc),
                query: {
                    searchPage: this.page,
                    searchOrder: doc.order,
                    searchToken: this.searchToken
                }
            })
        }
    }
}
